/*
 * Top level module for the header
 */

define([
  "backbone",
  "marionette",
  "configuration/properties",
  "messaging/messenger",
  "modules/header/headerView",
  "modules/header/menuBar/menuBarModule",
  "modules/header/userMenu/userMenuModule",
  "modules/header/kbMenu/kbMenuModule",
  "modules/header/contextMenu/contextMenuModule",
  "modules/header/kbRefreshMenu/kbRefreshMenuModule",
], function (
  Backbone,
  Marionette,
  Properties,
  Messenger,
  HeaderView,
  MenuBarModule,
  UserMenuModule,
  KbMenuModule,
  ContextMenuModule,
  KbRefreshMenuModule,
) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "header";
      this.region = options.region;
      this._setUpVents();
    },
    show: function () {
      this.layout = new HeaderView.headerLayout({
        model: new Backbone.Model({
          applicationName: Properties.applicationName,
        }),
      });
      //trigger event to show dashboard if home button is pressed
      this.layout.on(
        "click:home",
        function () {
          if (
            !Messenger.reqres.request("user:is:reviewer") ||
            Messenger.reqres.request("user:is:reporter")
          ) {
            Messenger.save(function (success) {
              if (success) {
                //if the KB is set to show quick create as the home page, show that.
                var kbId = Messenger.reqres.request("active:kb");
                var canCreateTopic = Messenger.reqres.request("can:create:topic", kbId);
                var showQuickCreate =
                  canCreateTopic && Messenger.reqres.request("default:quick:create");
                if (showQuickCreate) {
                  Messenger.vent.trigger("show:quick:create");
                } else {
                  Messenger.vent.trigger("show:dashboard");
                }
                this.menuBar.setActiveItem(null);
              }
            }, this);
          } else {
            //They ARE a reviewer
            Messenger.save(function (success) {
              if (success) {
                //Show the Tasks area
                Messenger.vent.trigger("show:reviewer");
                Messenger.command.execute("change:menu", "tasks");
              }
            }, this);
          }
        },
        this,
      );
      this.menuBar = this.addSubModule(new MenuBarModule({ region: this.layout.menuBar }));
      this.userMenu = this.addSubModule(
        new UserMenuModule({ region: this.layout.userMenu, showAdmin: true }),
      );
      this.kbMenu = this.addSubModule(new KbMenuModule({ region: this.layout.kbMenu }));
      this.contextMenu = this.addSubModule(
        new ContextMenuModule({ region: this.layout.contextMenu }),
      );
      this.kbRefreshMenu = this.addSubModule(
        new KbRefreshMenuModule({ region: this.layout.refreshMenu }),
      );
      this.layout.on(
        "show",
        function () {
          this._showMenu();
        },
        this,
      );
      this.showRegion(this.layout);
    },
    _showMenu: function () {
      this.menuBar.show();
      this.userMenu.show();
      this.kbMenu.show();
      this.contextMenu.show();
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "toggle:home:button",
        function (selected) {
          if (selected) {
            this.layout.activateHomeButton();
          } else {
            this.layout.deactivateHomeButton();
          }
        },
        this,
      );
    },
  });
});
